import React from "react";
import {withContext} from "with-context";

export const ShopAppContext = React.createContext({});
export const withShopAppContext = withContext(ShopAppContext, "shopApp");
